import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//  authod: zhangxiaoliang
//  date: 2020-11-10
//  name: 新增树型数据
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { selectMeterTreeList, houseTreeList } from '@/api/PMS/baseInformation/meterManager';
export default {
  data: function data() {
    return {
      data: [],
      chooseList: [],
      // 选中的集合
      defaultProps: {
        children: 'pmsTree',
        label: 'name'
      }
    };
  },
  created: function created() {
    this.init();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  props: ['keyModel', 'showDialog'],
  methods: {
    init: function init() {
      if (this.keyModel.shareType === 1) {
        this.defaultProps = {
          children: 'pmsTree',
          label: 'name'
        };
        this.loadMeterTree();
      } else if (this.keyModel.shareType === 0) {
        this.defaultProps = {
          children: 'pmsTree',
          label: 'name'
        };
        this.loadAreaTree();
      }
    },
    // 选中事件
    handleCheck: function handleCheck(data, check) {
      var _this = this;

      console.log(data, check);
      this.chooseList = [];
      check.checkedNodes.forEach(function (element) {
        if (element.flag === '211') {
          _this.chooseList.push(element);
        }
      }); // this.chooseList = check.checkedNodes
    },
    loadMeterTree: function loadMeterTree() {
      var _this2 = this;

      // 加载仪表树
      var treeQuery = {
        flag: 1000,
        areaId: this.keyModel.areaId // console.log(this.keyModel,treeQuery)

      };
      houseTreeList(treeQuery).then(function (response) {
        _this2.data = response.data.data;
        console.log(response.data.data);
      });
    },
    loadAreaTree: function loadAreaTree() {
      var _this3 = this;

      // 加载区域树
      var treeQuery = {
        flag: 1000,
        areaId: this.keyModel.areaId
      };
      houseTreeList(treeQuery).then(function (response) {
        _this3.data = response.data.data;
        console.log(response.data.data);
      });
    },
    setCurrentKey: function setCurrentKey(model) {
      // 初始化页面时默认选中第一个节点
      this.$refs.tree.$emit('node-click', model, null, this.$refs.tree);
      setTimeout(function () {
        document.getElementsByClassName('el-tree-node__content')[0].style.background = '#85a9d8';
      }, 60);
    },
    // 取消
    handCancle: function handCancle() {
      this.$emit('handCancle', null);
    },
    // 确定
    handConfirm: function handConfirm() {
      this.$emit('handCancle', this.chooseList);
    },
    filterNode: function filterNode(value, data) {
      // 查询树
      if (!value) {
        return true;
      }

      return data.name.indexOf(value) !== -1;
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      if (data.flag === '0') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanliquyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '1') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fenzu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '2') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'louyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '21') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'danyuan'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '211') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fangjian'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '212') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanggaowei'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '3') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'cheku'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '31') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'chewei'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '2111') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'yibiaopan'
          }
        }), h("span", [node.label])]);
      }
    }
  }
};